<!-- <div class="modal-body pdf-viewer"> -->
  <ng-container *ngIf="!data">
    <p class="row justify-content-center no-schedule">Schedule is not available for this test</p>
  </ng-container>

  <ng-container *ngIf="data">
    <pdf-viewer [src]="data"  (error)="onLoadError($event)" [render-text]="true"
      [original-size]="false" class="pdf-viewer-frame">
    </pdf-viewer>
  </ng-container>

<!-- </div> -->



